// extracted by mini-css-extract-plugin
export var blockBtn = "registration-module--block-btn--598e3";
export var mainBtn = "registration-module--main-btn--7e338";
export var mainTitle = "registration-module--main-title--54be8";
export var registration = "registration-module--registration--95aed";
export var registration__course = "registration-module--registration__course--ef1d0";
export var registration__coursePrice = "registration-module--registration__course-price--56f70";
export var registration__form = "registration-module--registration__form--cd694";
export var registration__gift = "registration-module--registration__gift--dda66";
export var registration__icon = "registration-module--registration__icon--e3f9f";
export var registration__recommendation = "registration-module--registration__recommendation--1d8e3";
export var registration__subtitle = "registration-module--registration__subtitle--9cdf0";
export var registration__subtitleOrange = "registration-module--registration__subtitle--orange--7c016";
export var registration__text = "registration-module--registration__text--e662e";
export var registration__textLineThrough = "registration-module--registration__text--line-through--0dec0";
export var registration__title = "registration-module--registration__title--9b5a3";
export var registration__wrapper = "registration-module--registration__wrapper--3e524";